import {
  DatabaseOutlined,
  CoffeeOutlined,
  ReadOutlined,
  HeartOutlined,
  ApartmentOutlined,
  UploadOutlined,
  FileExcelOutlined
} from '@ant-design/icons';

const master = {
  id: 'group-master',
  title: 'Master',
  type: 'group',
  children: [
    // Master Data
    {
      id: 'master-data',
      title: 'Master Data',
      type: 'collapse',
      icon: DatabaseOutlined,
      children: [
        {
          id: 'master-food-type',
          title: 'Food Type',
          type: 'item',
          url: '/master/food-type',
          icon: CoffeeOutlined
        },
        {
          id: 'master-blog-category',
          title: 'Blog Category',
          type: 'item',
          url: '/master/blog-category',
          icon: ReadOutlined
        },
        {
          id: 'master-plan-category',
          title: 'Plan Category',
          type: 'item',
          url: '/master/plan-category',
          icon: ReadOutlined
        },
        {
          id: 'master-goal',
          title: 'Goal',
          type: 'item',
          url: '/master/goal',
          icon: ReadOutlined
        },
        {
          id: 'master-dietary',
          title: 'Dietary Preference',
          type: 'item',
          url: '/master/dietary-preference',
          icon: HeartOutlined
        },
        {
          id: 'master-exercise',
          title: 'Exercise Types',
          type: 'item',
          url: '/master/exercise-types',
          icon: ApartmentOutlined
        }
      ]
    },

    // File Management
    {
      id: 'master-file-management',
      title: 'File Management',
      type: 'collapse',
      icon: UploadOutlined,
      children: [
        {
          id: 'master-upload-file',
          title: 'Upload Food File',
          type: 'item',
          url: '/master/upload-food',
          icon: UploadOutlined
        },
        {
          id: 'master-upload-excel',
          title: 'Upload Excersice File',
          type: 'item',
          url: '/master/upload-excersice',
          icon: FileExcelOutlined
        }
      ]
    }
  ]
};

export default master;
